/**
 * 最纯净的请求
 */
let axios = null;
import qs from 'qs';

const _decode16 = str => {
    return str.replace(/\\x(\w{2})/g, function(_, $1) {
        return String.fromCharCode(parseInt($1, 16));
    });
};

export function init(_axios){
    axios = _axios;
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.defaults.transformRequest = [function (data, headers) {
        return qs.stringify(data);
    }];
    axios.defaults.transformResponse = [function (data) {
        data = _decode16(data);
        data = data.replace(/\n/g, '');
        try {
            data = JSON.parse(data);
        } catch (e) {
            data = {};
        }
        return data;
    }];
}

export function get() {
    if(!axios){
        throw new Error('axios is not defined!');
    }
    return axios.get.apply(axios, arguments);
}

export function post() {
    if(!axios){
        throw new Error('axios is not defined!');
    }
    return axios.post.apply(axios, arguments);
}
